import script from "./CookieConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=17ebb656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ebb656"]])

export default __exports__